// Generated by ReScript, PLEASE EDIT WITH CARE

import * as App from "./App.bs.js";
import * as Curry from "../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Config from "../Config.bs.js";
import * as ReactDom from "react-dom";
import * as Lib$PorterinFusionkitSentry from "../../node_modules/@porterin/fusionkit-sentry/src/Lib.bs.js";

var match = Config.Env.getEnv(undefined);

var tracesSampleRate = match !== 1 ? 0.1 : 0.0;

var match$1 = Config.Env.getEnv(undefined);

var sentryEnvironment = match$1 !== 1 ? "gcp-production" : "staging";

Curry._1(Lib$PorterinFusionkitSentry.React.initSentry, Lib$PorterinFusionkitSentry.React.init_options(Config.Env.getSentryDsn(undefined), undefined, undefined, sentryEnvironment, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, tracesSampleRate, undefined, undefined, 0.0, 0.0, undefined));

var setWebpackPublicPath = (function(path){
    return __webpack_public_path__ = path;
    });

if (Config.Env.getEnv(undefined) === /* Production */0) {
  setWebpackPublicPath(Config.Env.getCDNPath(process.env.INFRA_STACK));
}

var root = document.querySelector("#root");

if (!(root == null)) {
  ReactDom.render(React.createElement(App.App.make, {}), root);
}

export {
  tracesSampleRate ,
  sentryEnvironment ,
  setWebpackPublicPath ,
  
}
/* match Not a pure module */
